import { Component, Input, output, Renderer2, input, signal } from '@angular/core';
import { TranslateDirective } from "@ngx-translate/core";
import { sleep } from "../util/sleep.util";

@Component({
  selector: 'ActionIcon',
  imports: [TranslateDirective],
  template: `
    <div class="tooltip" (click)="iconClicked()">
      @if (tooltip) {
        <span class="tooltip-text mt-7 -ml-8" [translate]="tooltip"></span>
      }

      @if (type() === 'run') {
        <svg
            class="{{ class }} {{ tooltip ? 'w-5 h-4' : 'w-4 h-3' }}"
            viewBox="0 0 20 16"
            xmlns="http://www.w3.org/2000/svg"
        >
          <g
              stroke="currentColor"
              stroke-width="1.6"
              fill="none"
              fill-rule="evenodd"
              stroke-linecap="round"
              stroke-linejoin="round"
          >
            <path d="M19 1.776v4.668h-4.909M1 14.224V9.556h4.909"/>
            <path d="M3.054 5.666C3.897 3.4 5.904 1.703 8.37 1.173c2.466-.53 5.046.179 6.834 1.88L19 6.443M1 9.556l3.796 3.392c1.788 1.7 4.368 2.41 6.834 1.88 2.466-.531 4.473-2.228 5.316-4.494"/>
          </g>
        </svg>

      } @else if (type() === 'list') {
        <svg class="{{ class }} w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9zm3.75 11.625a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"/>
        </svg>

      } @else if (type() === 'stats') {
        <svg
            class="{{ class }} w-[18px] h-[18px]"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
        >
          <g
              stroke="currentColor"
              stroke-width="1.6"
              fill="none"
              fill-rule="evenodd"
              stroke-linecap="round"
              stroke-linejoin="round"
          >
            <path d="M16.368 12.114A8 8 0 0 1 1.08 10.122 8.002 8.002 0 0 1 5.8 1.664"/>
            <path d="M17 9.002A8.003 8.003 0 0 0 9 1v8.002h8Z"/>
          </g>
        </svg>

      } @else if (type() === 'queue') {
        <svg class="{{ class }} w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z"/>
        </svg>

      } @else if (type() === 'edit') {
        <svg
            class="{{ class }} w-[18px] h-[18px]"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
        >
          <g
              stroke="currentColor"
              stroke-width="1.6"
              fill="none"
              fill-rule="evenodd"
              stroke-linecap="round"
              stroke-linejoin="round"
          >
            <path
                d="M8.157 2.687H2.59A1.59 1.59 0 0 0 1 4.277V15.41c0 .878.712 1.59 1.59 1.59h11.133a1.59 1.59 0 0 0 1.59-1.59V9.843"/>
            <path d="M14.12 1.494a1.687 1.687 0 0 1 2.386 2.386l-7.554 7.554-3.18.795.794-3.18 7.554-7.555Z"/>
          </g>
        </svg>

      } @else if (type() === 'trash') {
        <svg
            class="{{ class }} hover:text-red-500 w-4 h-[18px]"
            viewBox="0 0 16 18"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M1 4.2h14m-1.556 0v11.2c0 .884-.696 1.6-1.555 1.6H4.11c-.859 0-1.555-.716-1.555-1.6V4.2m2.333 0V2.6c0-.884.696-1.6 1.555-1.6h3.112c.859 0 1.555.716 1.555 1.6v1.6m-4.666 4V13m3.112-4.8V13"
              stroke="currentColor"
              stroke-width="1.6"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
          />
        </svg>

      } @else if (type() === 'restore') {
        <span class="{{ class }} hover:text-green-500 w-4 h-[18px] fas fa-trash-restore"></span>

      } @else if (type() === 'ai-check') {
        <svg
            class="{{ class }} w-5 h-5 hover:text-purple-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 0 0-2.455 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
        </svg>
      }
    </div>

    <ul [class.hidden]="!expanded()" class="absolute text-gray-500 pt-2 z-40 cursor-pointer -ml-80">
      <ng-content></ng-content>
    </ul>
  `,
})
export class ActionIcon {
  static TOGGLE_DELAY_MS = 50;

  readonly type = input.required<'run' | 'list' | 'stats' | 'queue' | 'edit' | 'trash' | 'restore' | 'ai-check'>();
  @Input() tooltip: string;
  clicked = output<void>();
  class = 'cursor-pointer transition-colors duration-200 hover:text-blue-500 select-none';

  // signal, because it is changed after a delay and from a document listener outside the template
  readonly expanded = signal(false);

  private onClickListener;

  constructor(private renderer: Renderer2) {
  }

  async toggleItems() {
    await sleep(ActionIcon.TOGGLE_DELAY_MS);
    this.expanded.update(expanded => !expanded);

    // add/remove an on-demand listener to hide the expanded items when clicking outside the element
    if (this.expanded()) {
      if (!this.onClickListener) {
        // https://angular.io/api/core/Renderer2#listen
        this.onClickListener = this.renderer.listen(document, "click", () => {
          this.toggleItems();
        });
      }
    } else {
      this.onClickListener(); // 'unlisten'
      this.onClickListener = undefined;
    }
  }

  iconClicked() {
    this.clicked.emit();
    this.toggleItems();
  }
}
